import Navbar from '../components/Navbar/Navbar'
import Pharmas from '../components/Pharmas/Pharmas'
import PharmaProducts from '../components/PharmaProducts/PharmaProducts'
import Footer from '../components/Footer/Footer'


const Pharma = () => {
    return(
        <>
            <Navbar />
            <main className='pharma'>
                <h1>Farmacia</h1>
            </main>
            <Pharmas />
            <PharmaProducts />
            <Footer />
        </>
    )
}

export default Pharma